import { createSlice } from '@reduxjs/toolkit';
import { IntercomConfig, UserHash } from 'types/api.types';
import { LoadingState } from 'types/enums';
import { fetchIntercomConfigEffect } from './effects';

export interface IntercomState {
  intercomConfig?: IntercomConfig;
  userHash?: UserHash;
  intercomLoading: LoadingState;
}

export const intercomInitialState: IntercomState = {
  intercomLoading: LoadingState.PRISTINE,
};

const slice = createSlice({
  name: 'intercom',
  initialState: intercomInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIntercomConfigEffect.fulfilled, (state, { payload }) => {
        state.intercomConfig = payload.intercomConfig;
        state.userHash = payload.userHash;
        state.intercomLoading = LoadingState.FETCHED;
      })
      .addCase(fetchIntercomConfigEffect.pending, (state) => {
        state.intercomLoading = LoadingState.FETCHING;
      })
      .addCase(fetchIntercomConfigEffect.rejected, (state) => {
        state.intercomLoading = LoadingState.ERROR;
      });
  },
});

export const intercomReducer = slice.reducer;
